import React from 'react';
import { useTranslation } from 'react-i18next';
import { STATS_KEYS } from '../data/mock';

const Process = () => {
  const { t } = useTranslation();
  const items = t('process.items', { returnObjects: true });
  const statsLabels = t('process.stats', { returnObjects: true });

  return (
    <section id="process" className="relative py-28 md:py-36 border-t border-white/5">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <div className="text-[11px] tracking-[0.3em] uppercase text-[#5FE0C8] mb-5">{t('process.eyebrow')}</div>
            <h2 className="font-display text-[40px] md:text-[56px] leading-[1] tracking-tight">
              {t('process.heading1')} <span className="font-serif-i text-[#5FE0C8]">{t('process.heading2')}</span>
            </h2>
            <p className="mt-6 text-[15px] text-[#9A9A8E] leading-relaxed max-w-[360px]">
              {t('process.intro')}
            </p>
          </div>
          <div className="lg:col-span-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/5 rounded-2xl overflow-hidden">
              {items.map((p, i) => (
                <div key={i} className="bg-[#0B1C18] p-8 md:p-10 hover:bg-[#0E2A24] transition-colors" data-testid={`process-step-${i + 1}`}>
                  <div className="flex items-baseline gap-4">
                    <span className="font-display text-[40px] text-[#5FE0C8]">{String(i + 1).padStart(2, '0')}</span>
                    <h3 className="font-display text-[22px] tracking-tight">{p.title}</h3>
                  </div>
                  <p className="mt-4 text-[14px] text-[#9A9A8E] leading-relaxed">{p.body}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="mt-20 md:mt-28 grid grid-cols-2 md:grid-cols-4 gap-px bg-white/5 rounded-2xl overflow-hidden">
          {STATS_KEYS.map((k, i) => (
            <div key={k} className="bg-[#0B1C18] p-8 md:p-10" data-testid={`stat-${i}`}>
              <div className="font-display text-[36px] md:text-[48px] tracking-tight text-[#ECE9DF]">{k}</div>
              <div className="mt-2 text-[12px] tracking-[0.18em] uppercase text-[#7A7A7A] leading-snug">{statsLabels[i]?.v}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
